var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRemove = function SvgRemove(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "18px",
    viewBox: "0 0 15 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MacBookPro-2017",
    transform: "translate(-48.000000, -261.000000)",
    stroke: "#EE3430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(48.000000, 262.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,3 L2,14 C2,15.1045695 2.8954305,16 4,16 L11,16 C12.1045695,16 13,15.1045695 13,14 L13,3 L13,3",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,2 L4,1 C4,0.44771525 4.44771525,1.01453063e-16 5,0 L10,0 C10.5522847,-1.01453063e-16 11,0.44771525 11,1 L11,2 L11,2",
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 5.5,
    x2: 4.5,
    y2: 13.5,
    id: "Line-2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 5.5,
    x2: 10.5,
    y2: 13.5,
    id: "Line-2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 5.5,
    x2: 7.5,
    y2: 13.5,
    id: "Line-2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 2.5,
    x2: 14.5,
    y2: 2.5,
    id: "Line",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRemove, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/remove.c3adcf68.svg";
export { ForwardRef as ReactComponent };